import styled, { css } from 'styled-components';
import { mediaMaxWidth } from 'common/styles/breakpoints';

import { SIDE_BY_SIDE_LAYOUT, STACK_LAYOUT, VIRTUAL_CONTENT_TYPE_LINK_OUT } from '../../../constants';

const SIDE_BY_SIDE_CSS = css`
    display: grid;
    grid-template-columns: 1fr 40%;
    gap: 2rem;
`;

const STACKED_CSS = css`
    display: flex;
    flex-direction: column;
    gap: 4rem;
`;

const VIRTUAL_CONTENT_LAYOUTS = {
    [SIDE_BY_SIDE_LAYOUT]: SIDE_BY_SIDE_CSS,
    [STACK_LAYOUT]: STACKED_CSS,
};

const SINGLE_EMBED_CSS = css`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

const VirtualContentContainer = styled.div`
    ${(props) =>
        !props.$hasAltEmbed || props.$virtualContentType === VIRTUAL_CONTENT_TYPE_LINK_OUT
            ? SINGLE_EMBED_CSS
            : VIRTUAL_CONTENT_LAYOUTS[props.$layout]}
    height: 100%;

    ${mediaMaxWidth.medium`
        ${STACKED_CSS}
    `}
`;

export default VirtualContentContainer;
